import { useState, useEffect, useRef} from 'react';
import { QueryCommand, UpdateItemCommand, ScanCommand, DeleteItemCommand } from '@aws-sdk/client-dynamodb';
import WallboardPreview from './WallboardPreview';
import EditorControls from './EditorControls';
import { marshall, unmarshall } from '@aws-sdk/util-dynamodb';
import AlertDialogComponent from         '../Common/AlertDialogComponent';
import { 
    Input,
    Editable,
    EditableInput,
    EditablePreview,
    Tooltip,
    Button
    
} from '@chakra-ui/react';

function Editor({ board, setBoard, boardList, setBoardList, queues, setQueues, client, definitionTable, queueArnTable, ccxQueueIdTable, ccxQueues, setCcxQueues, symbeeStats }) {
    
    const [boardData, setBoardData] = useState(null);
    const [renaming, setRenaming] = useState(false);
    const [addingImg, setAddingImg] = useState(false);
    const [imgUrl, setImgUrl] = useState(null);
    const nameRef = useRef(null);
    /// extra pience of state to manage the combination of symbeeStats being a boolean and the ccxQueueFetch
    const [ccxReady, setCcxReady] = useState(false);
    
    
    //logic to allow the pencil icon to select the editable name field
    const handleSelectName = () => {
        setRenaming(true);
        nameRef.current.focus();
    };
    const handleUnselectName = () => {
        setRenaming(false);
    };
    
    //logic to allow the pencil icon to select the editable image URL field
    const handleSelectImg = () => {
        setAddingImg(true);
    };
    
    // event handler for the name input field
    const handleNameChange = (name) => {
        let tempBoardData = {...boardData};
        tempBoardData.name = name;
        setBoardData(tempBoardData);
        
    };
    
    //event handler for setting img
    const handleImgChange = (url) => {
        setImgUrl(url);
        console.log(url);
        
    };
    
      //event handler for setting img
    const saveImgChange = () => {
        console.log(imgUrl);
        let tempBoardData = {...boardData};
        tempBoardData.imgUrl = imgUrl;
        setBoardData(tempBoardData);
        setAddingImg(false);
        
    };
    
    ///Save the wallbaord definition
    const handleSave = async () => {
        if(!boardData.imgUrl) { boardData.imgUrl = null }
        console.log(boardData);
        const marshalledItem = marshall(boardData);
        console.log(marshalledItem);
        const command = new UpdateItemCommand({
        TableName: definitionTable,
        Key: {
          id: { S: boardData.id },
        },
        UpdateExpression: 'SET #n = :n, #l = :l, #w = :w, #t = :t, #q = :q',
        ExpressionAttributeNames: {
          '#n': 'name',
          '#l': 'layout',
          '#w': 'widgets',
          '#t': 'theme',
          '#q': 'imgUrl'
        },
        ExpressionAttributeValues: {
          ':n': marshalledItem.name,
          ':l': marshalledItem.layout,
          ':w': marshalledItem.widgets,
          ':t': marshalledItem.theme,
          ':q': marshalledItem.imgUrl,
        },
      });
     
      const response = await client.send(command);
      console.log(response); 
    };
    
    
    //delete the wallbaord in dynamo
    const handleDelete = async () => {
        const params = {
            TableName: definitionTable,
            Key: {
              id: { S: boardData.id }
            }
          };
        
        const command = new DeleteItemCommand(params);
        
        try {
            await client.send(command);
            console.log(`Item with id ${boardData.id} deleted successfully from table ${definitionTable}.`);
            setBoard(null);
        } catch (err) {
            console.log(`Error deleting item with id ${boardData.id} from table ${definitionTable}: ${err}`);
            throw err;
        }
        
    };
        
     //scan for a list of AWS queues
    useEffect(() => {
        if(client && queueArnTable){
            console.log('Start AWS queue scan');
            const fetchQueueArnData = async () => {
              const command = new ScanCommand({
                TableName: queueArnTable,
              });
            
              const response = await client.send(command);
              const items = [];
              for (var i = 0; i < response.Items.length; i++) {
                  if(response.Items[i].Status.S === 'ENABLED'){
                    items.push({name: response.Items[i].QueueName.S, arn: response.Items[i].QueueID.S });
                  }
              }
              items.sort((a, b) => {
                  const nameA = a.name.toLowerCase();
                  const nameB = b.name.toLowerCase();
                
                  if (nameA < nameB) {
                    return -1;
                  }
                
                  if (nameA > nameB) {
                    return 1;
                  }
                
                  return 0;
                });
              setQueues(items);
              
            };
            
            fetchQueueArnData();
        }
    }, [client, queueArnTable, setQueues]);
    
     //scan for a list of CCX queues
    useEffect(() => {
        if(client && ccxQueueIdTable && symbeeStats){
            console.log('start CCX Queue scan');
            const fetchCCXQueueData = async () => {
              const command = new ScanCommand({
                TableName: ccxQueueIdTable,
              });
            
              const response = await client.send(command);
              console.log(response)
              const items = [];
              for (var i = 0; i < response.Items.length; i++) {
    
                items.push({name: response.Items[i].queueName.S, arn: response.Items[i].queueId.S, taskType: response.Items[i].taskType.S });
              }
              items.sort((a, b) => {
                  const nameA = a.name.toLowerCase();
                  const nameB = b.name.toLowerCase();
                
                  if (nameA < nameB) {
                    return -1;
                  }
                
                  if (nameA > nameB) {
                    return 1;
                  }
                
                  return 0;
                });
              setCcxQueues(items);
              setCcxReady(true)
              console.log('CCX Queues Found: ', items)
              
            };
            
            fetchCCXQueueData();
        }
        else {
            setCcxReady(true);
        }
    }, [client, ccxQueueIdTable, setCcxQueues, symbeeStats]);
    
    useEffect(() => {
        if(client && definitionTable) {
            const fetchData = async () => {
              const command = new QueryCommand({
                TableName: definitionTable,
                KeyConditionExpression: '#pk = :pk',
                ExpressionAttributeNames: { '#pk': 'id' },
                ExpressionAttributeValues: { ':pk': { S: board } },
              });
            
              const response = await client.send(command);
              setBoardData(response.Items.map(item => unmarshall(item))[0]);
            };
            
            fetchData();
        }
    }, [client, definitionTable, board]);
    
    
    if(boardData && queues && ccxReady) {
 
        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'space-evenly', padding: '1em', width: '100vw', height: '100vh', color: 'black'}}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '10vh', width: '100%'}}>
                
                    <span style={{display: 'flex', flexDirection: 'row', height: '15vh', width: '20%', justifyContent: 'start', alignItems: 'center'}}>
                    
                        {boardData.imgUrl && !addingImg ? <img alt='logo' src={boardData.imgUrl} style={{height: '8vh'}} /> : !addingImg ? <img alt='logo' src={process.env.PUBLIC_URL + "/images/one-nz-logo-black.png"} style={{height: '10vh'}} /> : null  }
                        { !addingImg ?
                        <Tooltip label='Edit Logo' aria-label='Edit Wallboard Logo'>
                            <img alt='change logo' src={process.env.PUBLIC_URL + "/images/edit.png"} style={{height: "12px", marginTop: '20%'}} onClick={handleSelectImg} />
                        </Tooltip>
                        :
                        <span style={{display: 'flex', flexDirection: 'column'}}>
                            <Input fontSize='s'onChange={(e)=> handleImgChange(e.target.value)} variant='outline' defaultValue={boardData.imgUrl} />
                            <Button onClick={saveImgChange}>Save Logo</Button>
                        </span>
                        }
                        
                    </span>
                    
                    <span style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '50%'}}>
                        { !renaming ?
                        <Tooltip label='Edit Name' aria-label='Edit wallboard name'>
                            <img alt='rename' src={process.env.PUBLIC_URL + "/images/edit.png"} style={{height: "24px", marginRight: '1em' }} onClick={handleSelectName} />
                        </Tooltip>
                        : null }
                        <Editable fontSize='3xl' defaultValue={boardData.name} onChange={(value)=> handleNameChange(value)} onBlur={handleUnselectName} onClick={handleSelectName} >
                          <EditablePreview ref={nameRef} />
                          <EditableInput />
                        </Editable>
                    </span>
                    <span style={{display: 'flex', flexDirection: 'row', width: '30%', justifyContent: 'space-evenly'}}>
                          <AlertDialogComponent handleAction={() => setBoard(null)} header='Exit Editor' body={`Any unsaved changes will be lost.`} logo='left' />
                          <AlertDialogComponent handleAction={handleSave} header='Save Wallboard' body={`Save all changes to the active wallbaord. These changes will be visible on next load in the viewer.`} logo='save' />
                          <AlertDialogComponent handleAction={handleDelete} header='Delete Wallboard' body={`Are you sure? You can't undo this action afterwards.`} logo='delete' />
                    </span>
                </div>
               
                <div style={{display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'space-evenly'}}>
                    <div className='wallboard' style={{display: 'flex', flexDirection: 'row', flexFlow: 'wrap', alignItems: 'center', justifyContent: 'space-evenly', width: '65vw', height: '65vh', background: boardData.theme.bgColor}}>
                        <WallboardPreview boardData={boardData} queues={queues} ccxQueues={ccxQueues}/>
                    </div>
                    <div style={{width: '35vw', height: '85vh'}}>
                        <EditorControls 
                            boardData={boardData}
                            setBoardData={setBoardData}
                            queues={queues}
                            setQueues={setQueues}
                            ccxQueues={ccxQueues}
                            setCcxQueues={setCcxQueues}
                            symbeeStats={symbeeStats}
                        />
                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems:'end', height: '100vh', width: '100vw'}}>
                <p>Loading</p>
            </div>
             
        );
 }
}

export default Editor;


